












import * as CurrentTime from '@/models/current-time/functions'

import _ from 'lodash'
import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

import DropdownSelect from '../../atoms/DropdownSelect.vue'
import { SelectItem } from '../../atoms/model/SelectItem'

@Component({
  components: {
    DropdownSelect,
  },
})
export default class YearDropdown extends Vue {
  @Prop({ required: true })
  readonly limit: number

  // 桁数
  @Prop({ required: true })
  readonly digits: number

  @Prop({ required: true })
  readonly value: string

  @Prop({ default: 'year' })
  readonly name: string

  @Prop({
    // default: 全ての要素を有効とする
    default: () => (() => false),
  })
  readonly disableFilter: (year: string) => boolean

  @Inject()
  readonly $validator: Validator

  get yearList(): SelectItem[] {
    const currentYear = CurrentTime.create().now.getFullYear()
    const yearRange: string[] = _.range(currentYear, currentYear + this.limit).map(v => (`0${v}`).slice(-this.digits))

    return [
      {
        value: '',
        text: 'YY',
        selected: _.isEmpty(this.value),
        disabled: true,
      },
      ...yearRange.map((year: string) => ({
        value: `${year}`,
        text: `${year}`,
        selected: year === this.value,
        disabled: this.disableFilter(year),
      })),
    ]
  }

  onInput(value) {
    this.$emit('input', value)
  }
}
